import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext(null);

export function ProfileProvider({ children }) {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [dash, setDash] = useState(null);
  const loadProfile = useCallback(async () => setProfile((await api.get("/profile")).data), []);
  const loadDash = useCallback(async () => setDash((await api.get("/dashboard")).data), []);
  useEffect(() => {
    if (user) {
      loadProfile().catch(() => {});
      loadDash().catch(() => {});
    }
  }, [user, loadProfile, loadDash]);
  const saveProfile = async (p) => {
    const r = await api.put("/profile", p);
    setProfile(r.data);
    return r.data;
  };
  return <Ctx.Provider value={{ profile, setProfile, saveProfile, dash, loadDash }}>{children}</Ctx.Provider>;
}

export const usePortfolio = () => useContext(Ctx);
